
<m-expansion-panel [id]="'hisConsulta-consultaSerasa'" [title]="'Consultas à Serasa ('+contadorHistoricoConsulta+')'" [active]="larguraEhSuperiorMin">
  <div *ngIf="contadorHistoricoConsulta > 0" class="table-responsive" id="div-table-hisConsulta-consultaSerasa">
    <table id="id-table-hisConsulta-consultaSerasa" class="table table-striped table-borderless" aria-label="Tabela de consulta parceiros" style="font-size: smaller;">
      <thead>
        <tr>
          <th scope="col">Empresa</th>
          <th scope="col">Data da consulta</th>
          <th scope="col">CNPJ</th>
          <th scope="col">Quantidade de consultas</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let passagem of historicoConsulta.passagens; index as i">
          <td>{{ passagem.empresa | naoinformado }}</td>
          <td>{{ passagem.data | naoinformado }}</td>
          <td>{{ passagem.cnpj | naoinformado }}</td>
          <td>{{ passagem.quantidadeConsultas | naoinformado }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div id="id-div-hisConsulta-falha"
    *ngIf="listaServicoFalha.includes('hist-consulta-passagem') || contadorHistoricoConsulta == 0">
    {{historicoConsulta.falhaServico.message}}
  </div>

  <app-alert [id]="'hisConsulta-mensagem'" [tipo]="'info'" >
    Esse relatório considera as consultas realizadas às soluções de crédito para o seu CPF nos últimos 2 (dois) anos contados a partir desta data na Serasa Experian. As consultas às soluções de crédito não representam negativações e não significam que você tenha realizado algum negócio com as empresas que consultaram seu CPF. Significa, apenas, que você pode ter buscado crédito ou o mercado pode estar interessado em oferecer crédito a você.
  </app-alert>
</m-expansion-panel>
